import { WALLET, WALLET_TYPE } from "../../constants";
import axios from "@helpers/axios/private.axios";
import store from "../../redux/store";

export const changeWallet = (wallet_obj) => async (dispatch) => {
  try {
    // Відправляємо запит на зміну активного гаманця на бекенді
    await axios.post("/wallet/change", {
      wallet_id: wallet_obj.id,
    });
    // Оновлюємо активний гаманець в стані Redux
    dispatch({
      type: WALLET.CHANGE_WALLET,
      payload: wallet_obj,
    });
  } catch (error) {
    // Error handling
  }
};

export const getWallets = () => async (dispatch) => {
  try {
    dispatch({ type: WALLET.WALLET_LOADING });
    const response = await axios.get("/wallet/all");
    const data = response.data.data;

    dispatch({
      type: WALLET.UPDATE_WALLETS,
      payload: {
        wallets: data,
        realWallet: data.find((el) => el.type === WALLET_TYPE.REAL_FUTURES),
      },
    });

    // ================== ВИПРАВЛЕНА ЛОГІКА ==================
    const currentActive = data.find((el) => el.active_now === 1);
    const demoFuturesWallet = data.find(
      (el) => el.type === WALLET_TYPE.DEMO_FUTURES
    );
    const realFuturesWallet = data.find(
      (el) => el.type === WALLET_TYPE.REAL_FUTURES
    );

    // Якщо активний гаманець НЕ ф'ючерсний (ні demo, ні real),
    // переключаємось на ф'ючерсний з пріоритетом:
    // 1. Спочатку на REAL_FUTURES (за замовчуванням усі на реальному рахунку)
    // 2. Потім на DEMO_FUTURES (якщо немає real)
    if (
      currentActive?.type !== WALLET_TYPE.DEMO_FUTURES &&
      currentActive?.type !== WALLET_TYPE.REAL_FUTURES
    ) {
      if (realFuturesWallet) {
        dispatch(changeWallet(realFuturesWallet));
      } else if (demoFuturesWallet) {
        dispatch(changeWallet(demoFuturesWallet));
      } else {
        dispatch({ type: WALLET.CHANGE_WALLET, payload: currentActive });
      }
    } else {
      // Якщо вже активний якийсь ф'ючерсний - залишаємо його
      dispatch({ type: WALLET.CHANGE_WALLET, payload: currentActive });
    }
    // ========================================================

    return data;
  } catch (error) {
    // Error handling
  }
};

export const updateWallets = () => async (dispatch) => {
  try {
    const response = await axios.get("/wallet/all");
    const data = response.data.data;
    dispatch({
      type: WALLET.UPDATE_WALLETS,
      payload: {
        wallets: data,
        realWallet: data.find((el) => el.type === WALLET_TYPE.REAL_FUTURES),
      },
    });
    return data;
  } catch (e) {
    // Error handling
  }
};

export const updateWalletEvent = () => (dispatch) => {
  let state = store.getState();
  if (state.channel && state.channel.user) {
    state.channel.user.listen("UpdateBalance", (e) => {
      const currentState = store.getState();
      const data = [...currentState.wallet.wallets];

      data.forEach((el) => {
        if (el.type === e.wallet.type) {
          el.balance = e.wallet.balance;
        }
      });
      dispatch({
        type: WALLET.UPDATE_WALLETS,
        payload: {
          wallets: data,
          realWallet: data.find((el) => el.type === WALLET_TYPE.REAL_FUTURES),
        },
      });
    });
  }
};
